import emailjs from '@emailjs/browser';
import toast from "react-hot-toast";
import { DEFAULT_EMAIL_CONTENT } from '../../enums/enums';

export const handleSendEmail = (values, resetForm) => {
  return toast.promise(
    emailjs.send(
      import.meta.env.VITE_EMAILJS_SERVICE_ID,
      import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
      values,
      import.meta.env.VITE_EMAILJS_PUBLIC_KEY
    ),
    {
      loading: 'Sending message...',
      success: () => {
        resetForm();
        return 'Message sent!';
      },
      error: 'Failed to send message!'
    }
  );
};